import { ReactTFC } from "../../utils/fp/missing-ts-parts";

import { css } from "@emotion/react";
import { CSS_SPACER_SIZES } from "../../styles/styles-css-variables";
import React from "react";
import { DealerPageData, ExtractSwarovskiPageData } from "@swo/storefront";
import { CSS_MQ } from "../../styles/breakpoints";
import { SimpleAspectRatio } from "../_shared-components/SimpleAspectRatio";
import { MapElementWithPin } from "./MapElementWithPin";
import { transformImageIfFromContentful_jpg } from "../../domain/contentful/transform-image-if-from-contentful";

type CoordinatesT = NonNullable<
  ExtractSwarovskiPageData<DealerPageData>["data"]["dealerDetails"]["address"]
>["coordinates"];

export const DealerDetailsVisual: ReactTFC<{
  coordinates: CoordinatesT;
  imageUrl: string | null | undefined;
  dealerId: string;
  name: string;
  apiKey: string;
}> = props => {
  const MapElement = props.coordinates ? (
    <MapElementWithPin coordinates={props.coordinates} name={props.name} apiKey={props.apiKey} />
  ) : null;

  const ImageElement = props.imageUrl ? (
    <img
      css={css`
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      `}
      src={transformImageIfFromContentful_jpg(props.imageUrl, 800)}
      alt={props.name}
    />
  ) : null;

  return (
    <React.Fragment>
      <SimpleAspectRatio
        css={[
          baseStyles,
          css`
            grid-area: main-visual;
          `,
        ]}
      >
        {ImageElement || MapElement}
      </SimpleAspectRatio>

      {ImageElement && (
        <SimpleAspectRatio
          css={[
            baseStyles,
            css`
              grid-area: additional-visual;
            `,
          ]}
        >
          {ImageElement && MapElement}
        </SimpleAspectRatio>
      )}
    </React.Fragment>
  );
};

const baseStyles = css`
  margin-bottom: ${CSS_SPACER_SIZES.md};

  ${CSS_MQ.atMostMd} {
    margin-left: calc(-1 * var(--content-gutter));
    margin-right: calc(-1 * var(--content-gutter));
  }
`;
